"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTextCell = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const table_cell_styles_1 = require("../partials/table-cell.styles");
exports.StyledTextCell = (0, styled_components_1.default)(table_cell_styles_1.StyledCommonTextTableCell) `
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  color: ${({ theme }) => theme.palette.text.secondary};

  &.cell-text--small {
    font-size: 0.75rem;
    line-height: 1.2rem;
  }
`;
